import { ProfileCircleIcon } from '@/common/icons/general'
import { IconType } from '@/common/icons/types'

interface IDefaultAvatar {
  firstName?: string | null
  lastName?: string | null
}
export const DefaultAvatar = ({ firstName, lastName }: IDefaultAvatar) => {
  const getInitials = (firstName?: string | null, lastName?: string | null) => {
    return `${firstName?.substring(0, 1) ?? ''}${lastName?.substring(0, 1) ?? ''}`
  }

  return (
    <div className="text-sm font-medium text-gray-900 p-4">
      <div className="w-10 h-10 bg-primary-100 flex items-center justify-center rounded-full">
        {getInitials(firstName, lastName)}

        {!firstName && !lastName && (
          <ProfileCircleIcon
            className="text-lg text-gray-500 group-hover:text-primary"
            type={IconType.Outline}
          />
        )}
      </div>
    </div>
  )
}

export default DefaultAvatar
